import {
  EmptySectionCard,
  InquiryCoverageCard,
  InquiryCoverageCardProps,
  InquiryDetailSectionHeader,
  SkeletonLoader,
} from '@equip.health/ui';

import { Section } from '~/components/common/Section';

export interface CoveragesProps extends React.PropsWithChildren {
  coverages: InquiryCoverageCardProps[];
  id: string;
  isLoading: boolean;
}

export const Coverages = ({
  children,
  coverages,
  id,
  isLoading,
}: CoveragesProps) => {
  const TOPLEVEL_ID = `${id}__coverage`;

  const coverageCards =
    coverages.length > 0 ? (
      coverages.map((props) => (
        <InquiryCoverageCard key={props.id} {...props} />
      ))
    ) : (
      <EmptySectionCard caption="No coverage has been added" id={TOPLEVEL_ID} />
    );

  return (
    <Section id={TOPLEVEL_ID}>
      <InquiryDetailSectionHeader
        count={coverages.length}
        id={`${TOPLEVEL_ID}-header`}
        title="Coverage"
      >
        {children}
      </InquiryDetailSectionHeader>
      <SkeletonLoader id={TOPLEVEL_ID} isLoaded={!isLoading}>
        <Section id={`${TOPLEVEL_ID}-children`}>{coverageCards}</Section>
      </SkeletonLoader>
    </Section>
  );
};
